/**
 * @generated SignedSource<<52647bcda0ce131aadf2fe7ebf8bf40b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type VoiceGender = "FEMALE" | "MALE" | "%future added value";
export type VoicePlatform = "azure" | "google" | "openai" | "%future added value";
export type VoiceType = "Neural" | "Standard" | "%future added value";
export type useTtsVoicesQuery$variables = {
  lang: string;
};
export type useTtsVoicesQuery$data = {
  readonly ttsVoices: {
    readonly sampleTexts: ReadonlyArray<string>;
    readonly voices: ReadonlyArray<{
      readonly gender: VoiceGender;
      readonly id: string;
      readonly name: string;
      readonly platform: VoicePlatform;
      readonly type: VoiceType;
    }>;
  };
};
export type useTtsVoicesQuery = {
  response: useTtsVoicesQuery$data;
  variables: useTtsVoicesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lang"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lang",
        "variableName": "lang"
      }
    ],
    "concreteType": "TtsVoices",
    "kind": "LinkedField",
    "name": "ttsVoices",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TtsVoice",
        "kind": "LinkedField",
        "name": "voices",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gender",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "platform",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sampleTexts",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTtsVoicesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTtsVoicesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0121d10fed5193712f77b14fafd3647",
    "id": null,
    "metadata": {},
    "name": "useTtsVoicesQuery",
    "operationKind": "query",
    "text": "query useTtsVoicesQuery(\n  $lang: String!\n) {\n  ttsVoices(lang: $lang) {\n    voices {\n      id\n      name\n      gender\n      type\n      platform\n    }\n    sampleTexts\n  }\n}\n"
  }
};
})();

(node as any).hash = "8fa41af162071595017e08607a337e96";

export default node;
